import { intercomSendData, intercomTrackEvent } from './intercomHelper'

export default function logVisitedVenueToIntercom(id, name, slug) {

  const payload = {
    'Last visited venue name': name,
    'Last visited venue slug': slug,
    'Last visited venue id': id
  }

  intercomSendData(payload);
  intercomTrackEvent('visited_venue', payload);
}
